import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import SearchContainer from '../components/SearchContainer/SearchContainer'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Container } from 'react-bootstrap'
import axios from 'axios'
import TrendingProducts from '../components/TrendingProducts/TrendingProducts'

function Search() {
    const { currentLocal } = useSelector((state) => state.currentLocal);
  const [searchValue, setSearchValue] = useState("");
    const [products, setProducts] = useState([]);
      const [relatedProduct, setRelatedProduct] = useState([])

  const handleSearch = async (e) => {

    const value = e.target.value;
    setSearchValue(value);

    if (!value) {
      setProducts([]);
      return;
    }

    try {
      const res = await axios.get(
        `https://nanosoft.technology/outlaw/api/search?query=${value}`
      );
      console.log(res?.data?.data?.results?.product?.items);
      
      setProducts(res?.data?.data?.results?.product?.items || []);
    } catch (error) {
      alert(Object.values(error?.response?.data?.errors || {})[0]?.[0] || "Search failed");
    }
  };
  console.log(relatedProduct);
  
  useEffect(() => {
    const getAllApis = async () => {

      await axios
        .get(`https://nanosoft.technology/outlaw/api/products`)
        .then(async (res) => {
          
          setRelatedProduct(res.data.data);

          

        })
        .catch((error) => {

          console.log(error);


        });
    }
    getAllApis()
  }, [])
console.log(products,"products");

  return (
    <div>
      <Navbar/>
      <div className='bg-light d-flex justify-content-center align-items-center'style={{
        height: "15vh",

      }}>
<Link to="/">{currentLocal.home.home} / {currentLocal.home.search}</Link>
      </div>
      <Container>
        
            <div style={{  }}>
              <div className="w-100 my-2  mb-4 position-relative">
                <input
                  placeholder={currentLocal?.home?.search || "Search..."}
                  className={
                    currentLocal?.language === "English"
                      ? "w-100 text-start h-100 py-1 py-2"
                      : "w-100 text-end h-100 py-1 px-2"
                  }
                  style={{ height: "40px" }}
                  value={searchValue}
                  onChange={handleSearch}
                />
                <div
                  className={
                    currentLocal?.language === "English"
                      ? "searsh_icon"
                      : "ar_searsh_icon"
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="gray"
                    className="bi bi-search"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 
                  1.398h-.001q.044.06.098.115l3.85 
                  3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 
                  1 0 0 0-.115-.1zM12 
                  6.5a5.5 5.5 0 1 1-11 
                  0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>

                {searchValue ? 
                        <SearchContainer
                      searchkey={searchValue}
                      products={products}
                    />
                :
                <p className='mt-4 fw-bold text-danger text-center'>{currentLocal.home.notfound}</p>
                }
              </div>

              {/* Quick Links */}

            </div>

      </Container>

                                  {relatedProduct.length>0&&
          <TrendingProducts
            products={relatedProduct && relatedProduct}
          />
}
      <Footer/>

    </div>
  )
}

export default Search